import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import styles from 'assets/jss/material-dashboard-pro-react/components/sidebarStyle';
import SidebarWrapper from './subcomponents/SidebarWrapper';
import Brand from './subcomponents/Brand';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import Search from './subcomponents/Search';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISidebarProps {
	bgColor?: types.sidebar.bgColor;
	rtlActive?: boolean;
	color: types.sidebar.color;
	image: string;
	routes: types.routes.ISingleDashboardRoute[];
	miniEnabled: boolean;
	open: boolean;
	handleDrawerToggle: () => void;
	pathname: string;
	onLinkClick: () => void;
}

const Sidebar = ({
	image,
	routes,
	bgColor = 'blue',
	rtlActive = false,
	color,
	miniEnabled,
	open,
	handleDrawerToggle,
	pathname,
	onLinkClick,
}: ISidebarProps) => {
	const [miniActive, setMiniActive] = useState<boolean>(true);
	const classes = useStyles();
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down('sm'));

	const drawerPaperClasses = classNames(classes.drawerPaper, {
		[classes.drawerPaperMini]: miniActive && miniEnabled,
		[classes.drawerPaperRTL]: rtlActive,
		[classes[bgColor + 'Background']]: true,
	});

	const anchor: 'left' | 'right' = useMemo(() => {
		return rtlActive ? 'right' : 'left';
	}, [rtlActive]);

	const onMouseOver = (): void => {
		if (!smDown) {
			setMiniActive(false);
		}
	};

	const onMouseOut = (): void => {
		if (!smDown) {
			setMiniActive(true);
		}
	};

	const onClose = (): void => {
		if (smDown) {
			handleDrawerToggle();
		}
	};

	return (
		<div>
			<Drawer
				variant={smDown ? 'temporary' : 'permanent'}
				anchor={anchor}
				open={!smDown || open}
				classes={{
					paper: drawerPaperClasses,
				}}
				onClose={onClose}
				ModalProps={{
					keepMounted: smDown, // Better open performance on mobile.
				}}
				onMouseOver={onMouseOver}
				onMouseOut={onMouseOut}
			>
				<Brand miniActive={miniActive} miniEnabled={miniEnabled} rtlActive={rtlActive} bgColor={bgColor} />
				<Search />
				<SidebarWrapper
					miniActive={miniActive}
					miniEnabled={miniEnabled}
					rtlActive={rtlActive}
					color={color}
					routes={routes}
					pathname={pathname}
					onLinkClick={onLinkClick}
				/>
				<ConditionalRender
					show={!!image}
					onTrue={() => (
						<div className={classes.background} style={{ backgroundImage: 'url(' + image + ')' }} />
					)}
				/>
			</Drawer>
		</div>
	);
};

export default Sidebar;
